import React, { useContext, useEffect } from 'react';
import { Container, Input } from './styles/SearchEventFrom.styled';
import SearchEventContext from '../context/SearchEventContext';
import SearchEventButtons from './SearchEventButtons';
import SearchEventFormSelect from './SearchEventFormSelect';
import ReactDatePicker from './ReactDatePicker';
import DatePickerContext from '../context/DatePickerContext';

export default function SearchEventForm({
  inputType,
  inputTextPlaceholder,
  selectOptions,
  selectOptions02,
  dir,
}) {
  const {
    displayMenu,
    displayFormInputs,
    searchValue,
    setSearchValue,
    clear,
    setSelectEventType,
    setSelectEventDepartment,
    selectEventType,
    selectEventDepartment,
    setSearchCurrValue,
  } = useContext(SearchEventContext);
  const { setCurrDateLabel } = useContext(DatePickerContext);

  useEffect(() => setSearchValue(''), [clear]);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      if (searchValue) setCurrDateLabel('');
      setSearchCurrValue(searchValue);
    }
  };

  return (
    <Container id="searchEventForm_1" clicked={displayMenu} className="eventsearch_container">
      <Input
        type={inputType || 'text'}
        placeholder={inputTextPlaceholder}
        value={searchValue}
        onChange={({ target }) => setSearchValue(target.value)}
        onKeyDown={handleKeyDown}
        clicked={displayMenu}
        delayShowUp={displayFormInputs}
        className="event_input"
        dir={dir}
      />
       <ReactDatePicker
        type="month"
        clicked={displayMenu}
        delayShowUp={displayFormInputs}
        dir={dir}
      />
       <SearchEventFormSelect
        option={selectEventType}
        setOption={setSelectEventType}
        options={selectOptions || []}
        dir={dir}
      />
      <SearchEventFormSelect
        option={selectEventDepartment}
        setOption={setSelectEventDepartment}
        options={selectOptions02 || []}
        dir={dir}
      /> 
      <SearchEventButtons dir={dir} /> 
    </Container>
  );
}
